<template>

    <v-container class="fill-height" style="display: block;" fluid>
        
        <v-card class="card">
            <v-card-title>Support Form</v-card-title>

            <v-divider />

            <v-card-text class="card-body">
                <v-form ref="supportForm" :lazy-validation="true" v-model="formValid">
                <v-row dense>
                    <v-col cols="12" sm="6">
                        <v-select v-model="selectedSupportType" :items="supoprtTypes" outlined label="Support Type" color="#c42111" :rules="[validation.required(selectedSupportType, 'Support Type')]" />
                    </v-col>

                    <v-col cols="12" sm="6">
                        <v-text-field v-model="supportSubject" outlined label="Support Subject" color="#c42111" :rules="[validation.required(supportSubject, 'Support Subject')]" ></v-text-field>
                    </v-col>

                    <v-col cols="12">
                        <v-textarea v-model="supportText" outlined no-resize label="Description" color="#c42111" :rules="[validation.required(supportText, 'Description')]" />
                    </v-col>

                    <v-col cols="12" sm="12" lg="4">
                        <div class="special-container">
                            <div class="scroll-container">
                                <span class="special-title">Screenshots</span>
                                <template v-for="(screenshot, index) in $store.state.screenshots" v-if="$store.state.screenshots.length">
                                    <div class="screenshot-container">
                                        <div class="image-container">
                                            <img :src="screenshot.data" />
                                        </div>
                                        <div class="info-container">
                                            <span class="image-title" v-text="screenshot.area" />
                                            <span class="image-time" v-text="screenshot.displayTime" />
                                            <span class="image-size" v-text="getReadableFileSize(screenshot.size)" />
                                            <div class="image-buttons-container">
                                                <v-btn x-large icon @click="addScreenshot(screenshot)">
                                                    <v-icon>mdi-image-move</v-icon>
                                                </v-btn>
                                            </div>
                                        </div>
                                    </div>
                                </template>

                                <div class="no-screenshots-container" v-if="!$store.state.screenshots.length">
                                    <v-icon class="no-screenshots-icon">mdi-image-off</v-icon>
                                    <span class="no-screenshots-text">No screenshots. Press (ctrl + shift + enter) to take an application screenshot.</span>
                                </div>

                            </div>
                        </div>
                    </v-col>

                    <v-col cols="12" sm="12" lg="8">
                        <div class="special-container">
                            <div class="scroll-container">
                                <span class="special-title">Attachments</span>
                                <v-simple-table id="file-list-table" dark v-if="attachments.length">
                                    <template v-slot:default @click="imagePreview">
                                    <thead>
                                        <tr>
                                            <th class="text-left">Name</th>
                                            <th class="text-left">Type</th>
                                            <th class="text-left">Size</th>
                                            <th class="text-left"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(attachment, index) in attachments" :key="index">
                                            <td>{{ attachment.name }}</td>
                                            <td>{{ attachment.type }}</td>
                                            <td>{{ getReadableFileSize(attachment.size) }}</td>
                                            <td class="text-right">
                                                <v-btn icon @click="deleteAttachment(attachment)"><v-icon>mdi-delete</v-icon></v-btn>
                                            </td>
                                        </tr>
                                    </tbody>
                                    </template>
                                </v-simple-table>

                                <div class="file-error" v-if="error">
                                    <span v-text="error" />
                                </div>

                                <vue-dropzone ref="myVueDropzone" id="file-dropzone" :class="{'drag-active': dragActive}" :options="dropzoneOptions" :useCustomSlot=true @vdropzone-file-added="handler" 
                                    @vdropzone-drag-enter="dragActive = true" @vdropzone-drag-over="dragActive = true" @vdropzone-drag-leave="dragActive = false" :include-styling="false">
                                    <div class="dropzone-custom-content">
                                        <h3 class="title">Drag and drop to attach file</h3>
                                        <div class="subtitle">or click to select a file from your computer</div>
                                    </div>
                                </vue-dropzone>
                            </div>
                        </div>
                    </v-col>

                    <v-col cols="12" sm="6">
                        <v-text-field v-model="emailAddress" outlined label="Email Address" color="#c42111" :rules="[validation.email(emailAddress)]"></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6">
                        <v-checkbox v-model="sendCopy" color="#c42111" label="Email me a copy of this form." />
                    </v-col>

                </v-row>
                </v-form>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn @click="submitSupportForm" text>Submit</v-btn>
            </v-card-actions>
        </v-card>


        <v-dialog v-model="showSuccess" max-width="80%" width="400px" :persistent="true" v-if="showSuccess">
            <v-card>
                <v-card-title class="result-title-success">Support Email Success</v-card-title>
                <v-divider />
                <v-card-text>
                    <span class="result-text" v-html="`Thank you for submitting your <b>${this.selectedSupportType}</b>.`" />
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn @click="clearForm" text>Ok</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showError" max-width="80%" width="400px" :persistent="true" v-if="showError">
            <v-card>
                <v-card-title class="result-title-error">Support Email Error</v-card-title>
                <v-divider />
                <v-card-text>
                    <span class="result-text" v-html="`We encountered an error submitting your <b>${this.selectedSupportType}</b>. Please contact <a href=mailto:support@telsasoft.com>Telsasoft Support</a> directly.`" />
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn @click="showError = false" text>Ok</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
    </v-container>

</template>

<script>
import vue2Dropzone from 'vue2-dropzone';
export default {
    name: 'Support',
    props: [],
    components: {
        vueDropzone: vue2Dropzone
    },
    data: () => ({
        formValid: true,
        supoprtTypes: ['Question', 'Issue', 'Feature Request', 'Feedback'],
        selectedSupportType: null,
        supportSubject: '',
        supportText: null,
        validation: {
            required: (value, fieldName) => ((value || value === 0) ? true : false) || `${fieldName} is required`,
            email: (value) => (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(value) || "Invalid email address"),
        },
        showSuccess: false,
        showError: false,
        attachments: [],

        maxFileSizeBytes: 52430000, // actually 50MB
        error: '',
        dropzoneOptions: {
            url: (TELSA.apiHost + "sitebook/files/upload"),
            thumbnailWidth: 150,
            maxFilesize: 9999999999,
            parallelUploads: 6,
            autoQueue: false,
            createImageThumbnails: false,
            previewTemplate: '<div></div>',
        },
        showImagePreview: false,
        imagePreview: null,
        dragActive: false,

        emailAddress: '',
        sendCopy: false,
        webappAuthKey: null
    }),

    computed: {
    },

    methods: {
        submitSupportForm: function() {
            if(this.$refs.supportForm.validate()) {
                TELSA.loading(true);
                let route = 'https://page.telsasoft.com/api/v1/support/email';
                let supportEmailObj = {
                    type: this.selectedSupportType,
                    subject: this.supportSubject,
                    text: this.supportText,
                    username: this.$store.state.user.user_username,
                    fullname: this.$store.state.user.user_fullname,
                    email: this.emailAddress,
                    attachments: this.attachments,
                    sendCopy: this.sendCopy,
                    customer: this.$store.state.batchConfig.licensee
                }
                return this.$http.post(route, {args: {supportEmailObj: supportEmailObj}, webapp_auth_key: this.webappAuthKey}).then(response => {
                    let result = response.body;
                    if(result.includes('success')) {
                        this.showSuccess = true;
                    }
                    else {
                        this.showError = true;
                    }
                    TELSA.loading(false);
                });
            }
        },

        clearForm: function() {
            this.selectedSupportType = null;
            this.supportText = null;
            this.showSuccess = false;
            this.showError = false;
            this.attachments = [];
            this.$refs.supportForm.reset();
        },

        getReadableFileSize: function(size) {
            return TELSA.readableFileSize(size);
        },

        deleteAttachment: function(attachment) {
            this.attachments.splice(this.attachments.indexOf(attachment), 1);
            this.error = '';
        },

        handler: function(file) {
            this.dragActive = false;
            // Check if file breaks any rules
            if(this.attachments.find(a => {return a.name == file.name;})) {
                // duplicate found
                this.error = `File ${file.name} already exists. You must delete the existing one first or rename it.`;
                return;
            }
            if(file.size > this.maxFileSizeBytes) {
                // File too big
                this.error = `File size exceeds maximum size of ${TELSA.readableFileSize(this.maxFileSizeBytes)}.`;
                return;
            }
            this.error = '';

            let fileObj = {
                name: file.name,
                type: file.type,
                size: file.size,
                data: ''
            };
            let self = this;
            let reader = new FileReader();
            reader.onload = function (e) {
                self.attachments.push(fileObj);
                fileObj.data = e.target.result;
            }
            reader.readAsDataURL(file);
        },

        addScreenshot: function(screenshot) {
            if(this.attachments.find(a => {return a.name == screenshot.name;})) {
                // duplicate found
                this.error = `File ${screenshot.name} already exists. You must delete the existing one first or rename it.`;
                return;
            }
            this.error = '';
            this.attachments.push({
                name: screenshot.name,
                type: screenshot.type,
                size: screenshot.size,
                data: screenshot.data
            });
        },

        getWebappAuthKey: function() {
            let route = (TELSA.apiHost + "auth/keys");
            let args = {requested_keys: ['webapp_auth_key']}
            return this.$http.post(route, {args: args}).then(response => {
                let result = response.body;
                this.webappAuthKey = result.webapp_auth_key;
            });
        }
    },

    mounted() {
        this.emailAddress = this.$store.state.user.user_page_email || '';
        this.getWebappAuthKey();
    },

    created() {
    },
};
</script>

<style scoped>
    .card {
        overflow-y: auto;
        /* max-height: calc(100vh - 180px); */
        height: calc(100vh - 80px);
    }
    .card-body {
        overflow-y: auto;
        height: calc(100% - 118px);
    }

    .result-title-success {
        color: #4caf50;
    }
    .result-title-error {
        color: #ff5252;
    }

    .result-text {
        margin-top: 1em;
        display: block;
    }

    .special-container {
        border: rgb(192, 192, 192) solid 1px;
        border-radius: 4px;
        padding: 1em;
        margin-bottom: 1em;
        display: block;
        position: relative;
        min-height: 200px;
    }

    .special-container .special-title {
        color: rgba(255, 255, 255, 0.7);
        font-size: 10pt !important;
        display: block;
        position: absolute;
        top: -12px;
        background-color: #424242;
        z-index: 1;
        padding-left: 3px;
        padding-right: 3px;
    }

    .scroll-container {
        overflow: auto;
        max-height: calc(100vh - 555px);
    }


    #file-list-table {
        overflow: auto;
    }

    #file-dropzone {
        margin: 2em auto;
        width: 100%;
        max-width: 1000px;
        border: #000000 solid 1px;
        text-align: center;
        padding: 2em;
        cursor: pointer;
        background-color: rgba(48,48,48,0.75);
    }

    #file-dropzone.drag-active {
        border: #4caf50 solid 1px;
        background-color: rgba(48,48,48,0.5);
    }

    .file-error {
        animation: shake-horizontal 0.3s cubic-bezier(0.455, 0.030, 0.515, 0.955) both;
        color: #ff5252;
        margin-top: 0.5em;
        margin-left: 1em;
    }

    #file-dropzone .title {
        color: #ffffff;
        font-size: 1.25rem !important;
        font-weight: 500;
        line-height: 2rem;
        letter-spacing: 0.0125em !important;
        font-family: "Roboto", sans-serif !important;
    }
    #file-dropzone .subtitle {
        color: #ffffff;
    }




    .no-screenshots-container {
        margin-top: 8px;
        width: 100%;
        text-align: center;
    }
    .no-screenshots-container .no-screenshots-icon {
        color: rgba(0, 0, 0, 0.6);
        font-size: 100px;

    }
    .no-screenshots-container .no-screenshots-text {
        display: block;
        font-size: 18px;
        margin: 0 60px;
        color: rgba(0, 0, 0, 0.6);
        font-weight: bold;
    }

    .screenshot-container {
        width: calc(100% - 2em);
        height: 140px;
        margin: 15px;
        position: relative;
    }

    .image-container {
        display: inline-block;
        width: 250px;
        height: 100%;
        margin-right: 10px;
        position: relative;
        text-align: center;

        float: left;
    }
    .image-container img {
        position: relative;
        max-width: 248px;
        max-height: 100%;
        border: rgba(255, 255, 255, 0.12) solid 1px;
    }

    .info-container {
        display: inline-block;
        width: calc(100% - 260px);
        height: 100%;

        float: left;
    }
    .info-container .image-title {
        display: block;
        font-size: 22px;
    }
    .info-container .image-time {
        display: block;
        font-size: 14px;
    }
    .info-container .image-size {
        display: block;
        font-size: 14px;
    }


    @keyframes shake-horizontal {
        0%,
        100% {
            transform: translateX(0);
        }
        10%,
        30%,
        50%,
        70% {
            transform: translateX(-10px);
        }
        20%,
        40%,
        60% {
            transform: translateX(10px);
        }
        80% {
            transform: translateX(8px);
        }
        90% {
            transform: translateX(-8px);
        }
    }


</style>

